import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { BaseResponse } from '@services/api/api-base.service'
import { map } from 'rxjs/operators'
import { ManagementApiBaseService } from '@services/api/management-api-base.service'
import { NoticeSessionBatch, NoticeSessionBatchPartialRequest } from '@models/planning/notice-session-batch.model'

@Injectable({
	providedIn: 'root'
})
export class NoticeSessionBatchService extends ManagementApiBaseService<any> {
	private readonly source: string

	constructor(override http: HttpClient) {
		super(http)
		this.source = 'notice-session-batches'
	}

	all(noticeSessionId: string) {
		return this.get<Array<NoticeSessionBatch>>(`${this.source}/${noticeSessionId}`).pipe(
			map(response => (response ?? []).map(it => new NoticeSessionBatch(it)))
		)
	}

	save(entity: NoticeSessionBatch) {
		return this.post<NoticeSessionBatch, BaseResponse>(`${this.source}`, entity)
	}

	update(id: string, entity: NoticeSessionBatchPartialRequest) {
		return this.put<NoticeSessionBatchPartialRequest, BaseResponse>(`${this.source}/${id}`, entity)
	}

	remove(id: string) {
		return this.delete<BaseResponse>(`${this.source}/${id}`)
	}
}
